// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.Audio_audioBrowserWrapper__TlvFa {
  /* max-width: 1200px; */
  width: 80%;
  margin: 0 auto;
  padding: 20px;
  direction: rtl;
  background: #f8f9fa;
  /* min-height: 100vh; */
}

.Audio_pageHeaderTitle__0e9Tv {
  text-align: center;
  margin-bottom: 40px;
  font-size: 28px;
  color: #1a202c;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.Audio_yearNavigationBar__F3GAA {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 40px;
  padding: 15px;
  margin-top: 50px;
  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);
  border-radius: 16px;
  box-shadow: 0 8px 25px rgba(26, 95, 63, 0.3);
}

.Audio_navigationButton__Qhqnu {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 20px;
  padding: 10px 16px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  transition: all 0.3s ease;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 75px;
  backdrop-filter: blur(10px);
}

.Audio_navigationButton__Qhqnu .Audio_arrowIcon__r3Vle {
  font-size: 20px;
  font-weight: bold;
}

.Audio_navigationButton__Qhqnu:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.2);
}

.Audio_navigationButton__Qhqnu:disabled {
  background: rgba(255, 255, 255, 0.1);
  cursor: not-allowed;
  color: rgba(255, 255, 255, 0.5);
  border-color: rgba(255, 255, 255, 0.2);
  transform: none;
  box-shadow: none;
}

.Audio_yearSelectionContainer__kBWnC {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.15);
  padding: 6px;
  border-radius: 16px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.Audio_yearSelectionBtn__LhmS7 {
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 8px 14px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease;
  width: 55px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(5px);
}

.Audio_yearSelectionBtn__LhmS7:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.4);
  transform: translateY(-1px);
}

.Audio_yearSelectionBtn__LhmS7.Audio_activeYearBtn__QX90U {
  background: rgba(255, 255, 255, 0.9);
  color: #1a5f3f;
  border-color: rgba(255, 255, 255, 0.9);
  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.3);
  font-weight: 700;
}

.Audio_yearRangeDots__Cr0D6 {
  color: rgba(255, 255, 255, 0.7);
  font-size: 18px;
  font-weight: bold;
  padding: 0 10px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.Audio_loadingIndicator__PBnQ7 {
  text-align: center;
  padding: 60px;
  color: #1a5f3f;
  font-size: 18px;
  font-weight: 600;
  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);
  border-radius: 16px;
  margin: 20px 0;
  box-shadow: 0 4px 12px rgba(26, 95, 63, 0.1);
}

.Audio_noAudioMessage__6LUf2 {
  text-align: center;
  padding: 60px;
  color: #64748b;
  font-size: 16px;
  background: linear-gradient(135deg, #f1f5f9 0%, #f8fafc 100%);
  border-radius: 16px;
  margin: 20px 0;
  border: 2px dashed #cbd5e1;
}

/* Fixed two-column grid layout with proper gap */
.Audio_audioRecordingsList__GJPkY {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
  align-items: start;
  width: 100%;
}

.Audio_audioItemCard__6ytwa {
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 16px;
  padding: 20px;
  transition: all 0.3s ease;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
  width: 100%;
  min-height: 80px;
  box-sizing: border-box;
}

.Audio_audioItemCard__6ytwa::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #1a5f3f 0%, #22543d 100%);
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.Audio_audioItemCard__6ytwa:hover {
  box-shadow: 0 12px 28px rgba(26, 95, 63, 0.15);
  transform: translateY(-4px);
  border-color: #1a5f3f;
}

.Audio_audioItemCard__6ytwa:hover::before {
  transform: scaleX(1);
}

.Audio_microphoneIconWrapper__IwHOf {
  margin-left: 16px;
  flex-shrink: 0;
  width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.Audio_microphoneIcon__PSNWq {
  width: 28px;
  height: 28px;
  filter: brightness(0) saturate(100%) invert(28%) sepia(24%) saturate(2476%) hue-rotate(128deg) brightness(94%) contrast(97%);
}

.Audio_audioContentSection__IUcHf {
  flex: 1 1;
  min-width: 0;
  padding: 0 16px;
}

.Audio_audioRecordingTitle__WrdzB {
  font-size: 16px;
  font-weight: 700;
  color: #1a202c;
  margin: 0 0 8px 0;
  line-height: 1.4;
  word-wrap: break-word;
  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.Audio_audioMetaInfo__BYHFF {
  font-size: 12px;
  color: #64748b;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}

.Audio_recordingDateTime__94dfc {
  color: #1a5f3f;
  font-weight: 600;
  background: rgba(26, 95, 63, 0.1);
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 11px;
}

.Audio_metaDataSeparator__EjEr9 {
  margin: 0 4px;
  color: #cbd5e1;
}

.Audio_speakerFullName__gGO22 {
  color: #475569;
  font-weight: 600;
  font-size: 11px;
}

.Audio_speakerProfileWrapper__Sa3to {
  margin-right: 16px;
  flex-shrink: 0;
}

.Audio_speakerProfileImage__f2wok {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  object-fit: cover;
  transition: all 0.3s ease;
}

.Audio_speakerProfileImage__f2wok:hover {
  border-color: #1a5f3f;
  transform: scale(1.05);
  box-shadow: 0 8px 16px rgba(26, 95, 63, 0.2);
}

.Audio_loadMoreAudioContainer__-rvcN {
  text-align: center;
  margin-top: 40px;
  padding: 30px;
  grid-column: 1 / -1; /* Span across both columns */
}

.Audio_showMoreAudioBtn__UiU-e {
  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);
  color: white;
  border: none;
  border-radius: 14px;
  padding: 16px 32px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 6px 20px rgba(26, 95, 63, 0.3);
  margin-bottom: 16px;
}

.Audio_showMoreAudioBtn__UiU-e:hover {
  background: linear-gradient(135deg, #16543e 0%, #1f4e3a 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(26, 95, 63, 0.4);
}

.Audio_audioCountDisplay__yVzXv {
  color: #64748b;
  font-size: 14px;
  font-weight: 500;
  background: rgba(26, 95, 63, 0.1);
  padding: 8px 16px;
  border-radius: 20px;
  display: inline-block;
}

/* Responsive design */
@media (max-width: 1024px) {
  .Audio_audioRecordingsList__GJPkY {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
  }
  
  .Audio_audioItemCard__6ytwa {
    padding: 16px;
  }
}

@media (max-width: 768px) {
  .Audio_audioBrowserWrapper__TlvFa {
    padding: 15px;
  }
  
  .Audio_audioRecordingsList__GJPkY {
    grid-template-columns: 1fr; /* Single column on mobile */
    gap: 16px;
  }
  
  .Audio_audioItemCard__6ytwa {
    flex-direction: row;
    text-align: right;
    padding: 20px;
  }
  
  .Audio_microphoneIconWrapper__IwHOf {
    margin-left: 16px;
  }
  
  .Audio_audioContentSection__IUcHf {
    padding: 0 16px;
  }
  
  .Audio_speakerProfileWrapper__Sa3to {
    margin-right: 16px;
  }
  
  .Audio_yearNavigationBar__F3GAA {
    flex-wrap: wrap;
    gap: 10px;
    width: 100%;
  }

  .Audio_yearSelectionBtn__LhmS7 {
    width: 46px;
  }
  
  .Audio_yearSelectionContainer__kBWnC {
    order: -1;
    width: 100%;
    justify-content: center;
  }
  
  .Audio_audioRecordingTitle__WrdzB {
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .Audio_audioItemCard__6ytwa {
    padding: 16px;
  }
  
  .Audio_microphoneIcon__PSNWq {
    width: 24px;
    height: 24px;
  }
  
  .Audio_speakerProfileImage__f2wok {
    width: 45px;
    height: 45px;
  }
  
  .Audio_audioRecordingTitle__WrdzB {
    font-size: 14px;
  }
  
  .Audio_audioMetaInfo__BYHFF {
    font-size: 11px;
  }

  .Audio_yearSelectionBtn__LhmS7 {
    width: 35px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Main pages/Audio.module.css"],"names":[],"mappings":";AACA;EACE,uBAAuB;EACvB,UAAU;EACV,cAAc;EACd,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,6DAA6D;EAC7D,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,+BAA+B;EAC/B,sCAAsC;EACtC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,sCAAsC;EACtC,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,6DAA6D;EAC7D,mBAAmB;EACnB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;EACf,6DAA6D;EAC7D,mBAAmB;EACnB,cAAc;EACd,0BAA0B;AAC5B;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4DAA4D;EAC5D,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,8CAA8C;EAC9C,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4HAA4H;AAC9H;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB,EAAE,6BAA6B;AACpD;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,gDAAgD;IAChD,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B,EAAE,4BAA4B;IACxD,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;IACT,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["\r\n.audioBrowserWrapper {\r\n  /* max-width: 1200px; */\r\n  width: 80%;\r\n  margin: 0 auto;\r\n  padding: 20px;\r\n  direction: rtl;\r\n  background: #f8f9fa;\r\n  /* min-height: 100vh; */\r\n}\r\n\r\n.pageHeaderTitle {\r\n  text-align: center;\r\n  margin-bottom: 40px;\r\n  font-size: 28px;\r\n  color: #1a202c;\r\n  font-weight: 700;\r\n  text-shadow: 0 2px 4px rgba(0,0,0,0.1);\r\n}\r\n\r\n.yearNavigationBar {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 12px;\r\n  margin-bottom: 40px;\r\n  padding: 15px;\r\n  margin-top: 50px;\r\n  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);\r\n  border-radius: 16px;\r\n  box-shadow: 0 8px 25px rgba(26, 95, 63, 0.3);\r\n}\r\n\r\n.navigationButton {\r\n  background: rgba(255, 255, 255, 0.2);\r\n  color: white;\r\n  border: 2px solid rgba(255, 255, 255, 0.3);\r\n  border-radius: 20px;\r\n  padding: 10px 16px;\r\n  cursor: pointer;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  transition: all 0.3s ease;\r\n  height: 44px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  min-width: 75px;\r\n  backdrop-filter: blur(10px);\r\n}\r\n\r\n.navigationButton .arrowIcon {\r\n  font-size: 20px;\r\n  font-weight: bold;\r\n}\r\n\r\n.navigationButton:hover:not(:disabled) {\r\n  background: rgba(255, 255, 255, 0.3);\r\n  border-color: rgba(255, 255, 255, 0.5);\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.navigationButton:disabled {\r\n  background: rgba(255, 255, 255, 0.1);\r\n  cursor: not-allowed;\r\n  color: rgba(255, 255, 255, 0.5);\r\n  border-color: rgba(255, 255, 255, 0.2);\r\n  transform: none;\r\n  box-shadow: none;\r\n}\r\n\r\n.yearSelectionContainer {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  background: rgba(255, 255, 255, 0.15);\r\n  padding: 6px;\r\n  border-radius: 16px;\r\n  backdrop-filter: blur(10px);\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.yearSelectionBtn {\r\n  background: rgba(255, 255, 255, 0.1);\r\n  color: white;\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n  border-radius: 12px;\r\n  padding: 8px 14px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  transition: all 0.3s ease;\r\n  width: 55px;\r\n  height: 40px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  backdrop-filter: blur(5px);\r\n}\r\n\r\n.yearSelectionBtn:hover {\r\n  background: rgba(255, 255, 255, 0.2);\r\n  border-color: rgba(255, 255, 255, 0.4);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.yearSelectionBtn.activeYearBtn {\r\n  background: rgba(255, 255, 255, 0.9);\r\n  color: #1a5f3f;\r\n  border-color: rgba(255, 255, 255, 0.9);\r\n  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.3);\r\n  font-weight: 700;\r\n}\r\n\r\n.yearRangeDots {\r\n  color: rgba(255, 255, 255, 0.7);\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n  padding: 0 10px;\r\n  height: 40px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.loadingIndicator {\r\n  text-align: center;\r\n  padding: 60px;\r\n  color: #1a5f3f;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);\r\n  border-radius: 16px;\r\n  margin: 20px 0;\r\n  box-shadow: 0 4px 12px rgba(26, 95, 63, 0.1);\r\n}\r\n\r\n.noAudioMessage {\r\n  text-align: center;\r\n  padding: 60px;\r\n  color: #64748b;\r\n  font-size: 16px;\r\n  background: linear-gradient(135deg, #f1f5f9 0%, #f8fafc 100%);\r\n  border-radius: 16px;\r\n  margin: 20px 0;\r\n  border: 2px dashed #cbd5e1;\r\n}\r\n\r\n/* Fixed two-column grid layout with proper gap */\r\n.audioRecordingsList {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  gap: 20px;\r\n  align-items: start;\r\n  width: 100%;\r\n}\r\n\r\n.audioItemCard {\r\n  display: flex;\r\n  align-items: center;\r\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\r\n  border-radius: 16px;\r\n  padding: 20px;\r\n  transition: all 0.3s ease;\r\n  border: 1px solid #e2e8f0;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\r\n  position: relative;\r\n  overflow: hidden;\r\n  width: 100%;\r\n  min-height: 80px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.audioItemCard::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: 3px;\r\n  background: linear-gradient(90deg, #1a5f3f 0%, #22543d 100%);\r\n  transform: scaleX(0);\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.audioItemCard:hover {\r\n  box-shadow: 0 12px 28px rgba(26, 95, 63, 0.15);\r\n  transform: translateY(-4px);\r\n  border-color: #1a5f3f;\r\n}\r\n\r\n.audioItemCard:hover::before {\r\n  transform: scaleX(1);\r\n}\r\n\r\n.microphoneIconWrapper {\r\n  margin-left: 16px;\r\n  flex-shrink: 0;\r\n  width: 50px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.microphoneIcon {\r\n  width: 28px;\r\n  height: 28px;\r\n  filter: brightness(0) saturate(100%) invert(28%) sepia(24%) saturate(2476%) hue-rotate(128deg) brightness(94%) contrast(97%);\r\n}\r\n\r\n.audioContentSection {\r\n  flex: 1;\r\n  min-width: 0;\r\n  padding: 0 16px;\r\n}\r\n\r\n.audioRecordingTitle {\r\n  font-size: 16px;\r\n  font-weight: 700;\r\n  color: #1a202c;\r\n  margin: 0 0 8px 0;\r\n  line-height: 1.4;\r\n  word-wrap: break-word;\r\n  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 2;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n}\r\n\r\n.audioMetaInfo {\r\n  font-size: 12px;\r\n  color: #64748b;\r\n  display: flex;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  gap: 4px;\r\n}\r\n\r\n.recordingDateTime {\r\n  color: #1a5f3f;\r\n  font-weight: 600;\r\n  background: rgba(26, 95, 63, 0.1);\r\n  padding: 2px 6px;\r\n  border-radius: 4px;\r\n  font-size: 11px;\r\n}\r\n\r\n.metaDataSeparator {\r\n  margin: 0 4px;\r\n  color: #cbd5e1;\r\n}\r\n\r\n.speakerFullName {\r\n  color: #475569;\r\n  font-weight: 600;\r\n  font-size: 11px;\r\n}\r\n\r\n.speakerProfileWrapper {\r\n  margin-right: 16px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.speakerProfileImage {\r\n  width: 50px;\r\n  height: 50px;\r\n  border-radius: 12px;\r\n  object-fit: cover;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.speakerProfileImage:hover {\r\n  border-color: #1a5f3f;\r\n  transform: scale(1.05);\r\n  box-shadow: 0 8px 16px rgba(26, 95, 63, 0.2);\r\n}\r\n\r\n.loadMoreAudioContainer {\r\n  text-align: center;\r\n  margin-top: 40px;\r\n  padding: 30px;\r\n  grid-column: 1 / -1; /* Span across both columns */\r\n}\r\n\r\n.showMoreAudioBtn {\r\n  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 14px;\r\n  padding: 16px 32px;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  box-shadow: 0 6px 20px rgba(26, 95, 63, 0.3);\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.showMoreAudioBtn:hover {\r\n  background: linear-gradient(135deg, #16543e 0%, #1f4e3a 100%);\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 8px 25px rgba(26, 95, 63, 0.4);\r\n}\r\n\r\n.audioCountDisplay {\r\n  color: #64748b;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  background: rgba(26, 95, 63, 0.1);\r\n  padding: 8px 16px;\r\n  border-radius: 20px;\r\n  display: inline-block;\r\n}\r\n\r\n/* Responsive design */\r\n@media (max-width: 1024px) {\r\n  .audioRecordingsList {\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n    gap: 16px;\r\n  }\r\n  \r\n  .audioItemCard {\r\n    padding: 16px;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .audioBrowserWrapper {\r\n    padding: 15px;\r\n  }\r\n  \r\n  .audioRecordingsList {\r\n    grid-template-columns: 1fr; /* Single column on mobile */\r\n    gap: 16px;\r\n  }\r\n  \r\n  .audioItemCard {\r\n    flex-direction: row;\r\n    text-align: right;\r\n    padding: 20px;\r\n  }\r\n  \r\n  .microphoneIconWrapper {\r\n    margin-left: 16px;\r\n  }\r\n  \r\n  .audioContentSection {\r\n    padding: 0 16px;\r\n  }\r\n  \r\n  .speakerProfileWrapper {\r\n    margin-right: 16px;\r\n  }\r\n  \r\n  .yearNavigationBar {\r\n    flex-wrap: wrap;\r\n    gap: 10px;\r\n    width: 100%;\r\n  }\r\n\r\n  .yearSelectionBtn {\r\n    width: 46px;\r\n  }\r\n  \r\n  .yearSelectionContainer {\r\n    order: -1;\r\n    width: 100%;\r\n    justify-content: center;\r\n  }\r\n  \r\n  .audioRecordingTitle {\r\n    font-size: 16px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .audioItemCard {\r\n    padding: 16px;\r\n  }\r\n  \r\n  .microphoneIcon {\r\n    width: 24px;\r\n    height: 24px;\r\n  }\r\n  \r\n  .speakerProfileImage {\r\n    width: 45px;\r\n    height: 45px;\r\n  }\r\n  \r\n  .audioRecordingTitle {\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .audioMetaInfo {\r\n    font-size: 11px;\r\n  }\r\n\r\n  .yearSelectionBtn {\r\n    width: 35px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"audioBrowserWrapper": `Audio_audioBrowserWrapper__TlvFa`,
	"pageHeaderTitle": `Audio_pageHeaderTitle__0e9Tv`,
	"yearNavigationBar": `Audio_yearNavigationBar__F3GAA`,
	"navigationButton": `Audio_navigationButton__Qhqnu`,
	"arrowIcon": `Audio_arrowIcon__r3Vle`,
	"yearSelectionContainer": `Audio_yearSelectionContainer__kBWnC`,
	"yearSelectionBtn": `Audio_yearSelectionBtn__LhmS7`,
	"activeYearBtn": `Audio_activeYearBtn__QX90U`,
	"yearRangeDots": `Audio_yearRangeDots__Cr0D6`,
	"loadingIndicator": `Audio_loadingIndicator__PBnQ7`,
	"noAudioMessage": `Audio_noAudioMessage__6LUf2`,
	"audioRecordingsList": `Audio_audioRecordingsList__GJPkY`,
	"audioItemCard": `Audio_audioItemCard__6ytwa`,
	"microphoneIconWrapper": `Audio_microphoneIconWrapper__IwHOf`,
	"microphoneIcon": `Audio_microphoneIcon__PSNWq`,
	"audioContentSection": `Audio_audioContentSection__IUcHf`,
	"audioRecordingTitle": `Audio_audioRecordingTitle__WrdzB`,
	"audioMetaInfo": `Audio_audioMetaInfo__BYHFF`,
	"recordingDateTime": `Audio_recordingDateTime__94dfc`,
	"metaDataSeparator": `Audio_metaDataSeparator__EjEr9`,
	"speakerFullName": `Audio_speakerFullName__gGO22`,
	"speakerProfileWrapper": `Audio_speakerProfileWrapper__Sa3to`,
	"speakerProfileImage": `Audio_speakerProfileImage__f2wok`,
	"loadMoreAudioContainer": `Audio_loadMoreAudioContainer__-rvcN`,
	"showMoreAudioBtn": `Audio_showMoreAudioBtn__UiU-e`,
	"audioCountDisplay": `Audio_audioCountDisplay__yVzXv`
};
export default ___CSS_LOADER_EXPORT___;
